import {
  RESOURCE_FILES_FETCH_REQUEST,
  RESOURCE_FILES_FETCH_SUCCESS,
  RESOURCE_FILES_FETCH_FAILURE,
  RESOURCE_FILE_UPLOAD_START,
  RESOURCE_FILE_UPLOAD_PROGRESS,
  RESOURCE_FILE_UPLOAD_SUCCESS,
  RESOURCE_FILE_UPLOAD_FAILURE,
  RESOURCE_FILE_UPLOADS_CLEAR,
  RESOURCE_FILE_UPDATE_REQUEST,
  RESOURCE_FILE_UPDATE_SUCCESS,
  RESOURCE_FILE_UPDATE_FAILURE,
  RESOURCE_FILE_DELETE_REQUEST,
  RESOURCE_FILE_DELETE_SUCCESS,
  RESOURCE_FILE_DELETE_FAILURE,
} from './ResourceFilesTypes';

const initialState = {
  files: [],
  loading: false,
  error: null,
  uploads: {},
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
};

export const resourceFilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESOURCE_FILES_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case RESOURCE_FILES_FETCH_SUCCESS:
      return { ...state, loading: false, files: action.payload, error: null };
    case RESOURCE_FILES_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case RESOURCE_FILE_UPLOAD_START:
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [action.payload.uploadId]: {
            fileName: action.payload.fileName,
            progress: 0,
            status: 'uploading',
            error: null,
          },
        },
      };
    case RESOURCE_FILE_UPLOAD_PROGRESS:
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [action.payload.uploadId]: {
            ...state.uploads[action.payload.uploadId],
            progress: action.payload.progress,
          },
        },
      };
    case RESOURCE_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [action.payload.uploadId]: {
            ...state.uploads[action.payload.uploadId],
            progress: 100,
            status: 'done',
          },
        },
      };
    case RESOURCE_FILE_UPLOAD_FAILURE:
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [action.payload.uploadId]: {
            ...state.uploads[action.payload.uploadId],
            status: 'error',
            error: action.payload.error,
          },
        },
      };
    case RESOURCE_FILE_UPLOADS_CLEAR:
      return { ...state, uploads: {} };

    case RESOURCE_FILE_UPDATE_REQUEST:
      return { ...state, updateLoading: true, updateError: null };
    case RESOURCE_FILE_UPDATE_SUCCESS:
      return { ...state, updateLoading: false, updateError: null };
    case RESOURCE_FILE_UPDATE_FAILURE:
      return { ...state, updateLoading: false, updateError: action.payload };

    case RESOURCE_FILE_DELETE_REQUEST:
      return { ...state, deleteLoading: true, deleteError: null };
    case RESOURCE_FILE_DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        files: state.files.filter((f) => f.fileId !== action.payload),
      };
    case RESOURCE_FILE_DELETE_FAILURE:
      return { ...state, deleteLoading: false, deleteError: action.payload };

    default:
      return state;
  }
};

export default resourceFilesReducer;
